import React from 'react';
import { FormGroup } from 'react-bootstrap';
import cookie from 'react-cookie';
import { beginsWithVowel } from '../../../helpers/HelperFunctions';
import Check from './Check';
import Radio from './Radio';

const checkParameters = (question, answerText, onAnswer) => {
  if (question == 'In what capacity are you hiring?') {
    if (
      cookie.load('post-capacity') == 'For my company' &&
      answerText == 'On behalf of my company'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-capacity') == 'For a personal project' &&
      answerText == 'As an individual for a personal project'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-capacity') == 'For a client or customer' &&
      answerText == 'On behalf of another company'
    ) {
      onAnswer(answerText);
      return true;
    }
  }

  if (question == 'Where are you in the hiring process?') {
    if (
      cookie.load('post-process') == "I'm ready to make a paid hire" &&
      answerText == "I'm ready to make a paid hire"
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-process') == 'I will possibly make a paid hire' &&
      answerText == 'I will possibly make a paid hire'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-process') == "I'm planning and researching" &&
      answerText == "I'm planning and researching"
    ) {
      onAnswer(answerText);
      return true;
    }
  }

  if (
    question ==
    'Is this an independent one off job, or part of a larger project?'
  ) {
    if (
      cookie.load('post-size') == 'Single job' &&
      answerText == 'Single job with no follow up work'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-size') == 'Single job with potential follow up work' &&
      answerText == 'Single job with follow up work'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      (cookie.load('post-size') == 'An ongoing project' ||
        cookie.load('post-size') == 'Part-time position (Contract)' ||
        cookie.load('post-size') == 'Full-time position (Contract)') &&
      answerText == 'Part of a larger ongoing project'
    ) {
      onAnswer(answerText);
      return true;
    }
  }

  if (question == 'For what period of time will the freelancer be needed?') {
    if (
      cookie.load('post-time') == 'A few hours' &&
      answerText == 'A few hours'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-time') == 'A day or two' &&
      answerText == 'A day or two'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-time') == 'Best part of a week' &&
      answerText == 'Best part of a week'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (
      cookie.load('post-time') == 'More than a week' &&
      answerText == 'More than a week'
    ) {
      onAnswer(answerText);
      return true;
    }
    if (cookie.load('post-time') == 'Long term' && answerText == 'Long term') {
      onAnswer(answerText);
      return true;
    }
  }

  return false;
};

const PostQuestion = ({
  answers = [],
  multi = false,
  firstQuestion = true,
  onAnswer,
  other = false,
  question = '',
  role = '',
  selectedAnswer = '',
  freelancer = '',
}) => {
  let titleMessage =
    'Great, you need ' +
    (beginsWithVowel(role) ? 'an' : 'a') +
    ' ' +
    role +
    '.';
  let subHeadingMessage =
    "We'll ask a few questions to match you to the right freelancers.";

  if (freelancer.hasOwnProperty('displayname')) {
    titleMessage = 'Great, you want to contact ' + freelancer.displayname + '.';
    subHeadingMessage = "We'll ask you a few questions about your project.";
  }
  return (
    <div className="lato-regular" id="post-brief-questions">
      {firstQuestion && (
        <div className="p mb bg-grey" style={{ borderRadius: '4px' }}>
          <p className="fs-15 mb lato-bold" style={{ lineHeight: '1.4em' }}>
            {titleMessage}
          </p>
          <p className="fs-15">{subHeadingMessage}</p>
        </div>
      )}
      <FormGroup>
        <p className="fs-15 lato-bold">{question}</p>
        <div style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
          {answers.map(function (answer, index) {
            return (
              <div
                className={
                  'post-brief-question' + (multi ? '-multi' : '') + '-answer'
                }
                style={{
                  borderTop: index === 0 ? 0 : '1px solid #ddd',
                  padding: '10px',
                }}
                key={index}
              >
                {multi && (
                  <Check
                    text={answer.text}
                    onSelected={() => onAnswer(answer.text)}
                    selected={
                      typeof selectedAnswer !== 'undefined' &&
                      selectedAnswer.indexOf(answer.text) !== -1
                    }
                  />
                )}
                {!multi && (
                  <Radio
                    text={answer.text}
                    onSelected={() => onAnswer(answer.text)}
                    selected={
                      selectedAnswer === answer.text ||
                      (!selectedAnswer &&
                        checkParameters(question, answer.text, onAnswer))
                    }
                  />
                )}
              </div>
            );
          })}
          {other && (
            <div
              className={
                'post-brief-question' + (multi ? '-multi' : '') + '-answer'
              }
              style={{ borderTop: '1px solid #ddd', padding: '10px' }}
            >
              {multi && (
                <Check
                  text="Other"
                  onSelected={() => onAnswer('other')}
                  selected={
                    typeof selectedAnswer !== 'undefined' &&
                    selectedAnswer.indexOf('other') !== -1
                  }
                />
              )}
              {!multi && (
                <Radio
                  text="Other"
                  onSelected={() => onAnswer('other')}
                  selected={selectedAnswer === 'other'}
                />
              )}
            </div>
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default PostQuestion;
